/**
 * Convention de noms de nœuds d'`export_model.py` dont dépend la circulation devinée dans la
 * géométrie ([[contrat-glb-site]], v0) : partagée par la couche 3D et l'outil de scénarios de démo.
 */
/** Sol praticable autour du bâtiment, au plancher le plus bas (m) : on sort par les portes de la façade. */
export const OUTDOOR_M = 12;

export type NavKind = 'stairs' | 'frames' | 'doors' | 'walls' | 'floor';

/** Bloquent le passage. */
const WALL_NODES = /^(walls|glass|pillars|railings|partition)/i;
/** Battants : le mur est percé dessous. */
const DOOR_NODES = /^doors$/i;
/** Cadres de portes : le mur est percé entre leurs montants (souvent continu derrière dans le GLB). */
const FRAME_NODES = /^walls_door_frames$/i;
const FLOOR_NODES = /^floor/i;
/** Escaliers : leur ligne de marche relie les étages. */
const STAIR_NODES = /^stairs/i;

/** Catégorie du premier nom reconnu, du nœud vers ses parents ; `null` : sans rôle pour la circulation. */
export function navKindOf(names: string[]): NavKind | null {
  for (const n of names) {
    if (STAIR_NODES.test(n)) return 'stairs';
    if (FRAME_NODES.test(n)) return 'frames';
    if (DOOR_NODES.test(n)) return 'doors';
    if (WALL_NODES.test(n)) return 'walls';
    if (FLOOR_NODES.test(n)) return 'floor';
  }
  return null;
}
